import { useNavigate } from "react-router-dom";
import TicketStatus from "../../TicketStatus/TicketStatus";
import getTime from "../../../../helpers/getTime.js";

/**
 * Individual Ticket Row Component
 * Updated for v2.0 API structure
 */
function Ticket({ ticket, index, showAssignee = false }) {
    let navigate = useNavigate();

    const getPriorityColor = (priority) => {
        const colors = {
            low: "#28a745",
            medium: "#ffa500",
            high: "#ff6b6b",
            urgent: "#dc3545",
        };
        return colors[priority] || "#6c757d";
    };

    const getPriorityBadge = (priority) => {
        return (
            <span
                style={{
                    background: getPriorityColor(priority),
                    color: "white",
                    padding: "2px 8px",
                    borderRadius: "8px",
                    fontSize: "10px",
                    fontWeight: "600",
                    textTransform: "uppercase",
                }}
            >
                {priority}
            </span>
        );
    };

    return (
        <tr
            onClick={() => {
                navigate(`/view-ticket/${ticket.id}`);
            }}
            style={{ 
                cursor: "pointer",
                borderBottom: "1px solid #f1f3f4",
                transition: "all 0.2s"
            }}
            onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#f8f9fa";
            }}
            onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
            }}
        >
            <td style={{ padding: "16px 20px", fontSize: "13px", color: "#6c757d" }}>{index + 1}</td>
            <td style={{ padding: "16px 20px" }}>
                <strong style={{ color: "#3bac75", fontSize: "13px", fontWeight: "600" }}>{ticket.ticketNumber}</strong>
            </td>
            <td style={{ padding: "16px 20px" }}>
                <div style={{ maxWidth: "300px" }}>
                    <div style={{ fontWeight: "600", marginBottom: "4px", fontSize: "14px", color: "#2c3e50" }}>
                        {ticket.subject}
                    </div>
                    {ticket.description && (
                        <div
                            style={{
                                fontSize: "12px",
                                color: "#6c757d",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {ticket.description.substring(0, 50)}...
                        </div>
                    )}
                </div>
            </td>
            <td style={{ padding: "16px 20px" }}>
                <div>
                    <div style={{ fontWeight: "500", fontSize: "13px", color: "#2c3e50" }}>{ticket.creatorName}</div>
                    <small style={{ color: "#6c757d", fontSize: "11px" }}>
                        {ticket.creatorEmail}
                    </small>
                </div>
            </td>
            <td style={{ padding: "16px 20px" }}>{getPriorityBadge(ticket.priority)}</td>
            <td style={{ padding: "16px 20px" }}>
                <TicketStatus status={ticket.status} />
            </td>
            <td style={{ padding: "16px 20px", fontSize: "12px", color: "#6c757d" }}>{getTime(ticket.created_at || ticket.createdAt)}</td>
            {showAssignee && (
                <td style={{ padding: "16px 20px" }}>
                    {ticket.assignedToName ? (
                        <span style={{ color: "#3bac75", fontWeight: "500", fontSize: "13px" }}>
                            {ticket.assignedToName}
                        </span>
                    ) : (
                        <span style={{ color: "#adb5bd", fontSize: "12px" }}>Unassigned</span>
                    )}
                </td>
            )}
        </tr>
    );
}

export default Ticket;
